module.exports = __webpack_public_path__ + "img/asudestico.bf631ac8.png";